import React from "react";

import { CircularProgress, Paper, Fab } from "@mui/material";
import { SRLWrapper } from "simple-react-lightbox";
import { makeStyles } from "tss-react/mui";

import { ChatMessageAttachmentFragment } from "@/gql/graphql";

import DownloadIcon from "../../../../components/Icons/DownloadIcon";
import If from "../../../../components/layout/If";
import Margin from "../../../../components/layout/Margin";

interface Props {
  attachment: ChatMessageAttachmentFragment;
  isUploaded: boolean;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    position: "relative",
    borderRadius: theme.spacing(2),
    backgroundColor: "#F7F9FB",
    overflow: "hidden",
  },
  downloadPosition: {
    position: "absolute",
    top: 0,
    right: 0,
  },
  download: {
    width: 38,
    height: 38,
    fontSize: 17,
    boxShadow: "none",
    "&:active": {
      boxShadow: "none",
    },
  },
  imageRoot: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxHeight: 320,
    maxWidth: 320,
    cursor: "pointer",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  progress: {
    width: "38px !important",
    height: "38px !important",
  },
}));

const AttachmentImage: React.FC<Props> = ({ attachment, isUploaded }) => {
  const { classes } = useStyles();

  return (
    <Paper className={classes.root} elevation={0}>
      <SRLWrapper
        options={{
          settings: {
            lightboxTransitionSpeed: 0.15,
            lightboxTransitionTimingFunction: "easeInOut",
            slideTransitionSpeed: 0.15,
          },
          buttons: {
            showAutoplayButton: false,
            showNextButton: false,
            showPrevButton: false,
            showThumbnailsButton: false,
            showDownloadButton: false,
          },
          thumbnails: {
            showThumbnails: false,
          },
        }}
      >
        <a className={classes.imageRoot} href={attachment.url}>
          <img
            className={classes.image}
            src={attachment.thumbnail}
            loading="lazy"
          />
        </a>
      </SRLWrapper>
      <div className={classes.downloadPosition}>
        <Margin all="7px">
          <If
            condition={isUploaded}
            then={
              <Fab
                className={classes.download}
                color="primary"
                aria-label="download"
                component="a"
                href={attachment.downloadUrl}
                download={attachment.filename}
                target="_blank"
              >
                <DownloadIcon fontSize="inherit" />
              </Fab>
            }
            else={<CircularProgress className={classes.progress} />}
          />
        </Margin>
      </div>
    </Paper>
  );
};

export default AttachmentImage;
